// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zayddlfC7Z41GbkzoDVn {
    background-color: #F8FAFF;
    min-height: calc(100vh - 75px);
    width: 65%;
    padding: 16px 32px 16px 0;
    box-sizing: border-box;
}

.chu0OAZSqtfENjuBVjPh {
    font-family: Raleway, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    margin-top: 16px;
}

.Z8uD5xFdOyTDtePRXFWA {
    display: flex;
    width: max-content;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    margin-top: 16px;
    margin-left: -8px;
}

.Z8uD5xFdOyTDtePRXFWA .Jisb7xX4PmN0TMezIBtC, .Z8uD5xFdOyTDtePRXFWA span {
    height: 27px;
}

.pswiCIgv7thV3ByA9tXp {
    background-color: white;
    padding: 24px;
    min-height: 200px;
}

.c2XDcuE37V5_gtfFqWUl {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin-top: 8px;
}

.X5NymLXgnaTvPGCT8PVr {
    margin-right: 8px;
}

.c2XDcuE37V5_gtfFqWUl p {
    margin: 0;
    font-size: 16px;
}

.srxEFotf_AWr9rXVcm5M {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.srxEFotf_AWr9rXVcm5M > div {
    width: 49%;
}

.PzuYEggRCfZTbpR1XvpO {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin: 16px 0 0 0;
}

.DXUi0qAEHtHaaDMNvobI {
    margin: 0;
    font-size: 14px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}) {
    .zayddlfC7Z41GbkzoDVn {
        width: 100%;
        padding: 16px;
        min-height: unset;
        box-sizing: border-box;

        position: fixed;
        margin-top: 75px;
        z-index: -10;

        max-height: calc(90vh - 75px);
        overflow: scroll;
        scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */
        scrollbar-width: thin;
    }

    .zayddlfC7Z41GbkzoDVn::-webkit-scrollbar {
        width: 5px;  /* for vertical scrollbars */
    }

    .zayddlfC7Z41GbkzoDVn::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }

    .chu0OAZSqtfENjuBVjPh {
        font-size: 20px;
        margin-top: 0;
        margin-bottom: 16px;
    }

    .pswiCIgv7thV3ByA9tXp {
        padding: 8px;
    }

    .srxEFotf_AWr9rXVcm5M {
        flex-direction: column;
    }

    .srxEFotf_AWr9rXVcm5M > div {
        width: 100%;
    }

    .Z8uD5xFdOyTDtePRXFWA {
        margin-bottom: 1.5rem;
    }

}
`, "",{"version":3,"sources":["webpack://./src/views/Investments/InvestmentsForm/InvestmentsForm.module.css"],"names":[],"mappings":"AAMA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,UAAU;IACV,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mDAAwB;AAC5B;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB,sBAAsB;;QAEtB,eAAe;QACf,gBAAgB;QAChB,YAAY;;QAEZ,6BAA6B;QAC7B,gBAAgB;QAChB,+CAA+C,EAAE,0BAA0B;QAC3E,qBAAqB;IACzB;;IAEA;QACI,UAAU,GAAG,4BAA4B;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;AAEJ","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n@value breakpoints: \"components/library/style/breakpoint.css\";\n@value mobile, tablet from breakpoints;\n\n.container {\n    background-color: #F8FAFF;\n    min-height: calc(100vh - 75px);\n    width: 65%;\n    padding: 16px 32px 16px 0;\n    box-sizing: border-box;\n}\n\n.title {\n    font-family: Raleway, sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 24px;\n    margin-top: 16px;\n}\n\n.link {\n    display: flex;\n    width: max-content;\n    align-items: center;\n    text-decoration: none;\n    font-weight: 500;\n    margin-top: 16px;\n    margin-left: -8px;\n}\n\n.link .icon, .link span {\n    height: 27px;\n}\n\n.form {\n    background-color: white;\n    padding: 24px;\n    min-height: 200px;\n}\n\n.invest {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    margin-top: 8px;\n}\n\n.checkbox {\n    margin-right: 8px;\n}\n\n.invest p {\n    margin: 0;\n    font-size: 16px;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.row > div {\n    width: 49%;\n}\n\n.subtitle {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    margin: 16px 0 0 0;\n}\n\n.hint {\n    margin: 0;\n    font-size: 14px;\n    color: color-text-subtle;\n}\n\n@media screen and (max-width: tablet) {\n    .container {\n        width: 100%;\n        padding: 16px;\n        min-height: unset;\n        box-sizing: border-box;\n\n        position: fixed;\n        margin-top: 75px;\n        z-index: -10;\n\n        max-height: calc(90vh - 75px);\n        overflow: scroll;\n        scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */\n        scrollbar-width: thin;\n    }\n\n    .container::-webkit-scrollbar {\n        width: 5px;  /* for vertical scrollbars */\n    }\n\n    .container::-webkit-scrollbar-thumb {\n        background: rgba(0, 0, 0, 0.1);\n        border-radius: 5px;\n    }\n\n    .title {\n        font-size: 20px;\n        margin-top: 0;\n        margin-bottom: 16px;\n    }\n\n    .form {\n        padding: 8px;\n    }\n\n    .row {\n        flex-direction: column;\n    }\n\n    .row > div {\n        width: 100%;\n    }\n\n    .link {\n        margin-bottom: 1.5rem;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}`,
	"container": `zayddlfC7Z41GbkzoDVn`,
	"title": `chu0OAZSqtfENjuBVjPh`,
	"link": `Z8uD5xFdOyTDtePRXFWA`,
	"icon": `Jisb7xX4PmN0TMezIBtC`,
	"form": `pswiCIgv7thV3ByA9tXp`,
	"invest": `c2XDcuE37V5_gtfFqWUl`,
	"checkbox": `X5NymLXgnaTvPGCT8PVr`,
	"row": `srxEFotf_AWr9rXVcm5M`,
	"subtitle": `PzuYEggRCfZTbpR1XvpO`,
	"hint": `DXUi0qAEHtHaaDMNvobI`
};
export default ___CSS_LOADER_EXPORT___;
